import styled from '@emotion/styled';
import { Box, Paper } from '@mui/material';

import { palette } from '../../theme';
export const ToiletCounterWrapperBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  overflow: 'hidden',
  border: `1px solid ${palette.line}`,
  width: 200,
  height: '40px',
  justifyContent: 'center'
});

export const ToiletCountItemBox = styled(Box)({
  flex: 1,
  backgroundColor: palette.lavender.main,
  borderRadius: 0,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
